var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcknowledgeNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#009de0;}.b{fill:#fff;}.c{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H40L0,40Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.001 4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.721,9.3H.886a.886.886,0,1,1,0-1.771h2.9V.98a.981.981,0,0,1,1.961,0V8.32c0,.019,0,.038,0,.058s0,.025,0,.037a.885.885,0,0,1-.886.886H4.721Z",
    transform: "matrix(0.695, 0.719, -0.719, 0.695, 9.69, 1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 16,
    height: 16
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcknowledgeNotification);
export default __webpack_public_path__ + "static/media/acknowledgeNotification.8b6579a4ca7dcc7447ce4c04cb0e34de.svg";
export { ForwardRef as ReactComponent };